import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';  // Import CloseIcon
import "./CustomButtonModal.css"
import {GetDocTypeItem } from "../../API/API";
import { GetData } from '../../API/getApi';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectUser} from '../../ReduxStore/userReducer';


// Reusable button with modal component
const CustomButtonModal = ({ buttonText, modalTitle, modalContent, onModalClose }) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [showData,setShowdata]=useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(selectUser);
  const jwtToken = userData?.JwtToken;
  const databaseName = userData?.DatabaseName;


//   const getDocType = async (DocEntry, DocType) => {
//     try {
//       const DocType = await GetData(
//         `${GetDocTypeItem}${databaseName}&DocEntry=${DocEntry}&DocType=${DocType}`,
//         {
//           headers: {
//             wg_token: jwtToken,
//           },
//         },
//         dispatch,
//         navigate
//       );


//   } catch (err) {
//     console.error('Error fetching data:', err);
//     setError(err.message);
//   } finally {
//     setLoading(false);
//   }
// };


const handleOpenModal = () => {
  setOpenModal(true);
};

const handleCloseFirstModal = () => {
  setOpenModal(false);
  if (onModalClose) {
    onModalClose(); // Call the onModalClose function passed as prop
  }
};

const handleCloseSecondModal = () => {
  setModalOpen(false);
};

const handleCloseBothModals = () => {
  setOpenModal(false);
  setModalOpen(false);
};

  const handleRowClick = async (value) => {
    setLoading(true);
  
    try {
      // Construct the request URL properly using the values
      const data = `${GetDocTypeItem}${databaseName}&DocEntry=${value.docEntry}&DocType=${value.doctype}`;
  
      // API call (assuming GetData returns a Promise)
      const DocType = await GetData(data, {
        headers: {
          wg_token: jwtToken,
        },
      }, dispatch, navigate);
      setShowdata(DocType.result);
      // console.log("showData",showData);
      
      // Log the response or set the state with the fetched data
      // console.log("Fetched data:", DocType);
      // You can update state with the fetched data if needed
      setModalOpen(true);
    } catch (err) {
      // console.error('Error fetching data:', err);
      setError(err.message); // Set error message to display in UI
    } finally {
      setLoading(false); // Set loading to false once the API call completes
    }
  };
  
{/* <CommonDynamicTable
data={modalContent}
dataType="CustomButtonModal"
onEditRow={handleRowClick}/>

<CommonDynamicTable
data={showData}/> */}

  return (
    <>
      <Button variant="outlined" className='d-flex flex-column' onClick={handleOpenModal}>
        <span className=''>{buttonText}</span>
        <div className="qty-total-container">
          {/* <Divider sx={{ my: 1 }} /> */}
          {/* <span className='qty'>Qty:</span> */}
          {/* <span className='total'>Total:</span> */}
        </div>
      </Button>

      <Dialog open={openModal} onClose={handleCloseFirstModal} maxWidth="lg" fullWidth className="first-modal">
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <table className="responsive-table1">
          {/* {Array.isArray(modalContent) && modalContent.map((index,value) => (
              <div key={index}>
                  <p>{value.docNum}</p>
                  <p>{value.docTotal}</p>
              </div>
          ))} */}
         <thead>
      <tr>
        
        <th>Doc Number</th>
        <th>Doc Total</th>
        
      </tr>
    </thead>
    <tbody>
      {Array.isArray(modalContent) && modalContent.map((value, index) => (
         <tr key={index} onClick={(event) => handleRowClick(value)}
         style={{ cursor: 'pointer' }}>
          {/* <td>{value.docEntry}</td> */}
          <td>{value.docNum}</td>
          <td>{value.docTotal}</td>
          {/* <td>{value.u_OpportNo}</td> */}
        </tr>
      ))}
    </tbody>
  </table>
          {/* <p>{modalContent}</p> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseFirstModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {modalOpen && (
  <Dialog open={modalOpen} onClose={handleCloseSecondModal} maxWidth="lg" fullWidth>
    <DialogTitle>{modalTitle}</DialogTitle>
    <Button 
              onClick={handleCloseBothModals} 
              style={{
                position: 'absolute', 
                right: 18, 
                top: 20, 
                minWidth: 'unset', 
                padding: 0 
              }}>
              <CloseIcon />
            </Button>
    <DialogContent dividers style={{ maxHeight: '70vh', overflowY: 'auto' }}>
    <table className="responsive-table1">
        <thead>
          <tr>
            <th>DocNum</th>
            <th>Item Code</th>
            <th>Item Name</th>
            <th>UOM</th>
            <th>Quantity</th>
            <th>BPL Name</th>
            <th>Price</th>
            <th>Total</th>
            
          </tr>
        </thead>
        <tbody>
          {Array.isArray(showData) && showData.map((item, index) => (
            <tr key={index} style={{ cursor: 'pointer' }}>
              
              <td>{item.DocNum}</td>
              <td>{item.Item_Code}</td>
              <td>{item.Item_Name}</td>
              <td>{item.UOM}</td>
              <td>{item.Quantity}</td>
              <td>{item.BPLName}</td>
              <td>{item.Price}</td>
              <td>{item.Total}</td>
              
            </tr>
          ))}
        </tbody>
        <tfoot>
                <tr>
                  <td colSpan="7" style={{ textAlign: 'right',fontWeight: 'bold' }}>Document Total:</td>
                  <td>{showData.length > 0 ? showData[showData.length - 1].Document_Total : ''}</td>
                </tr>
              </tfoot>
      </table>
    </DialogContent>
    <DialogActions>
          <Button onClick={handleCloseSecondModal} color="primary">
            Back
          </Button>
        </DialogActions>
  </Dialog>
)}
    </>
  );
};

export default CustomButtonModal;
